import axiosIns from '@/libs/axiosIns'

export default {
  namespaced: true,
  state: {
    mobileVersion: '',
  },
  getters: {
    mobileVersion: state => state.mobileVersion,
  },
  mutations: {
    setMobileVersion(state, version) {
      state.mobileVersion = version
    },
  },
  actions: {
    fetchMobileVersion({ commit }) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/MobileVersion')
          .then(response => {
            commit('setMobileVersion', response.data.version || '')
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    updateMobileVersion({ commit }, version) {
      return new Promise((resolve, reject) => {
        console.log('store, version :', version)
        axiosIns.put('/MobileVersion/', { version })
          .then(response => {
            commit('setMobileVersion', version)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
  },
}
